import React from 'react';
import { Formik } from 'formik';
import { useParams } from 'react-router-dom';

import FormWrapper from '~FormWrapper';
import PhonePlanForm from './PhonePlanForm';

import { useOnSubmit } from '~hooks/useOnSubmit';
import { useOnEdit } from '~hooks/useOnEdit';
import { isPhoneNumberValid, removeEmptyKeys } from '../validations';

const validate = values => {
  const errors = {};

  if (!values.accountNumber) {
    errors.accountNumber = 'Vaadittu';
  }

  errors.contactPhone = isPhoneNumberValid(values.contactPhone);

  if (!values.additionalInfo) {
    errors.additionalInfo = 'Vaadittu';
  }

  return removeEmptyKeys(errors);
};

const initialValues = {
  accountNumber: '',
  additionalInfo: '',
  contactPhone: '',
};

const PhonePlan = props => {
  const { formId, edit } = props;
  const { orderId } = useParams();

  const onFormSubmit = useOnSubmit();
  const onFormEdit = useOnEdit();

  return (
    <Formik
      initialValues={initialValues}
      validate={validate}
      onSubmit={async (values, { setSubmitting }) => {
        setSubmitting(true);
        const method = edit ? onFormEdit : onFormSubmit;
        await method({
          fields: {
            ...values,
          },
          setSubmitting,
          orderId,
          formId,
        });
      }}
    >
      {formikProps => (
        <FormWrapper
          {...props}
          title="Liittymähuolto"
          formik={formikProps}
          Component={PhonePlanForm}
        />
      )}
    </Formik>
  );
};

export default PhonePlan;
